/**
 * Sidebar entries, in the prototype's order. `page` is the backend permission key
 * (§8.13 of the plan); Phase 1 filters this list by the signed-in user's permissions.
 */
export type PageKey =
  | 'dashboard'
  | 'clients'
  | 'services'
  | 'notifs'
  | 'eng'
  | 'billing'
  | 'pwmgr'
  | 'users'
  | 'duedates'
  | 'audit'
  | 'myprofile';

export interface NavItem {
  page: PageKey;
  label: string;
  path: string;
  icon: string;
  /** Roadmap phase that delivers the screen (shown on placeholders until then). */
  phase: number;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { page: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: 'pi pi-th-large', phase: 3 },
  { page: 'clients', label: 'Client Master', path: '/clients', icon: 'pi pi-users', phase: 2 },
  { page: 'services', label: 'Services', path: '/services', icon: 'pi pi-briefcase', phase: 4 },
  { page: 'notifs', label: 'Inbox', path: '/inbox', icon: 'pi pi-inbox', phase: 5 },
  { page: 'eng', label: 'Documents', path: '/documents', icon: 'pi pi-file', phase: 6 },
  { page: 'billing', label: 'Billing', path: '/billing', icon: 'pi pi-dollar', phase: 7 },
  { page: 'pwmgr', label: 'Password Manager', path: '/vault', icon: 'pi pi-lock', phase: 8 },
  { page: 'users', label: 'User Management', path: '/users', icon: 'pi pi-user-edit', phase: 1 },
  { page: 'duedates', label: 'Due Date Master', path: '/due-dates', icon: 'pi pi-calendar', phase: 2 },
  { page: 'audit', label: 'Audit History', path: '/audit', icon: 'pi pi-history', phase: 1 },
  { page: 'myprofile', label: 'My Profile', path: '/me', icon: 'pi pi-id-card', phase: 1 },
];
